// extracted by mini-css-extract-plugin
export var chip = "_ga-0";
export var filterDropdown = "_ga-5";
export var filterItem = "_ga-6";
export var icon = "_ga-1";
export var removeButton = "_ga-3";
export var removeIcon = "_ga-4";
export var separator = "_ga-2";